<template>
	<div>
		<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
			<router-link :to="{path: '/tasks-types'}" class="btn btn-link">
				<font-awesome-icon :icon="['fas', 'chevron-left']"></font-awesome-icon>
			</router-link>
			<h1 class="h2">Добавление типа задач</h1>
			<div class="btn-toolbar mb-2 mb-md-0">
				<button type="button" class="btn btn-primary" @click="onAdd()">
					<font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
				</button>
				<!--
				<div class="btn-group me-2">
					<button type="button" class="btn btn-sm btn-outline-secondary">Share</button>
					<button type="button" class="btn btn-sm btn-outline-secondary">Export</button>
				</div>
				<button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle">
					<span data-feather="calendar"></span>
					This week
				</button>
				-->
			</div>
		</div>
		<b-overlay :show="overlay" rounded="lg" variant="white">
			<div class="row">
				<div class="col-md-6 offset-md-3">
					<div id="input-group-pos" role="group" class="form-group">
						<label id="input-group-pos" for="input-pos" class="d-block">Позиция типа задач:</label>
						<div>
							<input id="input-pos" type="number" class="form-control" v-model="pos" />
						</div>
					</div>
					<div id="input-group-name" role="group" class="form-group">
						<label id="input-group-name" for="input-name" class="d-block">Название типа задач:</label>
						<div>
							<input id="input-name" type="text" placeholder="Например: Проект" class="form-control" v-model="name" autofocus />
						</div>
					</div>
					<div id="input-group-is-default" role="group" class="form-group">
						<label id="input-group-is-default" for="checkbox-is-default" class="d-block">Тип задач по умолчанию:</label>
						<div>
							<input type="checkbox" id="checkbox-is-default" class="form-control" v-model="is_default" />
						</div>
					</div>
					<div id="input-group-default-title" role="group" class="form-group">
						<label id="input-group-default-title" for="input-default-title" class="d-block">Заголовок задач по умолчанию:</label>
						<div>
							<input id="input-default-title" type="text" class="form-control" v-model="default_title" />
						</div>
					</div>
					<div id="input-group-default-description" role="group" class="form-group">
						<label id="input-group-default-description" for="input-default-description" class="d-block">Описание задач по умолчанию:</label>
						<div>
							<textarea id="input-default-description" rows="3" class="form-control" v-model="default_description"></textarea>
						</div>
					</div>
					<div id="input-group-required-user-assigned" role="group" class="form-group">
						<label id="input-group-required-user-assigned" for="checkbox-required-user-assigned" class="d-block">Назначенный пользователь обязателен для заполнения:</label>
						<div>
							<input type="checkbox" id="checkbox-required-user-assigned" class="form-control" v-model="required_user_assigned" />
						</div>
					</div>
					<div id="input-group-required-estimate" role="group" class="form-group">
						<label id="input-group-required-estimate" for="checkbox-required-estimate" class="d-block">Оценка времени обязательна для заполнения:</label>
						<div>
							<input type="checkbox" id="checkbox-required-estimate" class="form-control" v-model="required_estimate" />
						</div>
					</div>
					<div id="input-group-required-date-deadline" role="group" class="form-group">
						<label id="input-group-required-date-deadline" for="checkbox-required-date-deadline" class="d-block">Дата дедлайна обязательна для заполнения:</label>
						<div>
							<input type="checkbox" id="checkbox-required-date-deadline" class="form-control" v-model="required_date_deadline" />
						</div>
					</div>
				</div>
			</div>
		</b-overlay>
		<div class="alert alert-info" v-html="result" v-if="result != ''"></div>
	</div>
</template>

<style lang="css">

</style>

<script>
import { useMeta } from 'vue-meta';
import BOverlay from '@/components/bootstrap/overlay.vue';

export default {
	name: 'TasksTypeAdd',
	setup(){
		useMeta({title: 'Добавление типа задач'});
	},
	data: () => ({
		overlay: false,
		
		pos: 0,
		name: '',
		is_default: 0,
		default_title: '',
		default_description: '',
		required_user_assigned: 0,
		required_estimate: 0,
		required_date_deadline: 0,
		
		result: '',
	}),
	computed: {
		token(){
			return this.$store.state.token;
		},
	},
	methods: {
		onAdd(){
			this.result = 'Добавление...';
			this.overlay = true;
			
			let formData = new FormData();
			formData.append('virtualspace_id', 1);
			formData.append('pos', this.pos);
			formData.append('name', this.name);
			formData.append('is_default', this.is_default);
			formData.append('default_title', this.default_title);
			formData.append('default_description', this.default_description);
			formData.append('required_user_assigned', this.required_user_assigned);
			formData.append('required_estimate', this.required_estimate);
			formData.append('required_date_deadline', this.required_date_deadline);
			
			fetch('/api/tasks-types', {
				method: 'POST',
				body: formData,
				headers: {
					Authorization: 'Bearer '+this.token,
				},
			}).then(stream => stream.json()).then(ret => {
				if(ret.success){
					this.$router.push('/tasks-types/'+ret.id);
				} else {
					if(ret.error) this.result = ret.error;
					this.overlay = false;
				}
			}).catch(error => {
				this.result = 'Ошибка! '+error;
				this.overlay = false;
				console.error(error);
			});
		},
	},
	beforeMount(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		next();
		window.scrollTo(0, 0);
	},
	components: {
		BOverlay,
	},
}
</script>